import { useContext } from "react";
import { ServiceContext } from "../context/ServiceContext";

export default function useServices() {
	return useContext(ServiceContext);
}
